"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackUnmountedSearchForm = exports.startListentBrowserBackAction = exports.setSearchOfferID = exports.setSearchHotelsString = exports.setQuery = exports.setNextAvailableSearchTime = exports.setLoadingHotels = exports.setLastLoadingHotelsByKey = exports.search = exports.resetNextAvailableSearchTime = exports.resetForm = exports.openPageBySearchOfferID = exports.getHotels = exports.fetchDepthDataByCountryID = exports.endListenBrowserBackAction = exports.clearSearchOfferID = exports.clearSearchHotelsString = void 0;
var _reduxActions = require("redux-actions");
var _createActions = (0, _reduxActions.createActions)({
    clearSearchHotelsString: function clearSearchHotelsString() {
      return '';
    },
    clearSearchOfferID: function clearSearchOfferID() {
      return '';
    },
    fetchDepthDataByCountryID: function fetchDepthDataByCountryID(queryID) {
      return queryID;
    },
    getHotels: function getHotels(countryID, rating, services) {
      return {
        countryID: countryID,
        rating: rating,
        services: services
      };
    },
    openPageBySearchOfferID: function openPageBySearchOfferID() {
      return undefined;
    },
    resetForm: function resetForm(queryID) {
      return queryID;
    },
    resetNextAvailableSearchTime: function resetNextAvailableSearchTime() {
      return undefined;
    },
    search: function search(queryID, values) {
      return {
        queryID: queryID,
        values: values
      };
    },
    setLastLoadingHotelsByKey: function setLastLoadingHotelsByKey(key) {
      return key;
    },
    setLoadingHotels: function setLoadingHotels(loading) {
      return loading;
    },
    setNextAvailableSearchTime: function setNextAvailableSearchTime(timestamp) {
      return timestamp;
    },
    setSearchHotelsString: function setSearchHotelsString(string) {
      return string;
    },
    setSearchOfferID: function setSearchOfferID(id) {
      return id;
    },
    setQuery: function setQuery(queryID) {
      return queryID;
    },
    endListenBrowserBackAction: function endListenBrowserBackAction() {
      return undefined;
    },
    startListentBrowserBackAction: function startListentBrowserBackAction(queryID) {
      return queryID;
    },
    trackUnmountedSearchForm: function trackUnmountedSearchForm() {
      return undefined;
    }
  }, {
    prefix: 'TS_SEARCH_FORM'
  }),
  clearSearchHotelsString = exports.clearSearchHotelsString = _createActions.clearSearchHotelsString,
  clearSearchOfferID = exports.clearSearchOfferID = _createActions.clearSearchOfferID,
  fetchDepthDataByCountryID = exports.fetchDepthDataByCountryID = _createActions.fetchDepthDataByCountryID,
  getHotels = exports.getHotels = _createActions.getHotels,
  openPageBySearchOfferID = exports.openPageBySearchOfferID = _createActions.openPageBySearchOfferID,
  resetForm = exports.resetForm = _createActions.resetForm,
  resetNextAvailableSearchTime = exports.resetNextAvailableSearchTime = _createActions.resetNextAvailableSearchTime,
  search = exports.search = _createActions.search,
  setLastLoadingHotelsByKey = exports.setLastLoadingHotelsByKey = _createActions.setLastLoadingHotelsByKey,
  setLoadingHotels = exports.setLoadingHotels = _createActions.setLoadingHotels,
  setQuery = exports.setQuery = _createActions.setQuery,
  setNextAvailableSearchTime = exports.setNextAvailableSearchTime = _createActions.setNextAvailableSearchTime,
  setSearchHotelsString = exports.setSearchHotelsString = _createActions.setSearchHotelsString,
  setSearchOfferID = exports.setSearchOfferID = _createActions.setSearchOfferID,
  endListenBrowserBackAction = exports.endListenBrowserBackAction = _createActions.endListenBrowserBackAction,
  startListentBrowserBackAction = exports.startListentBrowserBackAction = _createActions.startListentBrowserBackAction,
  trackUnmountedSearchForm = exports.trackUnmountedSearchForm = _createActions.trackUnmountedSearchForm;